import { withTheme, SvyTooltip as Tooltip } from '@innovorder/savory';

export const SvyTooltip = withTheme(Tooltip);
